<!-- Altın / sarrafiye stoku, alt tür bazında. Kaynak: kasa bakiyeleri + satılmamış ürünler. -->
<ng-container *ngIf="hasUserRole">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h6 class="text-uppercase text-muted mb-0">Altın ve Sarrafiye Stoku</h6>
    <span class="text-muted small">{{ scopeLabel }}</span>
  </div>

  <div class="alert alert-warning py-2 small d-flex align-items-center gap-2" *ngIf="error">
    <i class="bx bx-error"></i>
    <span class="flex-grow-1">Stok bilgisi okunamadı.</span>
    <button type="button" class="btn btn-sm btn-outline-warning" (click)="load()">Tekrar dene</button>
  </div>

  <div class="row g-3 mb-3" *ngIf="!error">
    <div class="col-xl-4 col-md-6" *ngFor="let card of cards; trackBy: trackByCurrency">
      <div class="card h-100 mb-0">
        <div class="card-header bg-transparent d-flex align-items-center gap-2 py-3">
          <div class="avatar-xs flex-shrink-0">
            <span class="avatar-title rounded-circle" [ngClass]="'bg-' + card.tone">
              <i class="font-size-16" [ngClass]="card.icon"></i>
            </span>
          </div>
          <h6 class="mb-0 flex-grow-1">{{ card.title }}</h6>
          <div class="text-end" *ngIf="!loading">
            <div class="fw-semibold">
              {{ card.totalHas | currencyAmount: GoldNew }} {{ GoldNew | currencyWeight: null }}
            </div>
            <small class="text-muted">toplam has</small>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="text-center py-4" *ngIf="loading">
            <span class="spinner-border spinner-border-sm text-muted" role="status"></span>
          </div>

          <div class="text-center text-muted small py-4" *ngIf="!loading && !card.rows.length">
            Stok yok.
          </div>

          <!-- Sarrafiye türleri çok olabilir; kart yüksekliği sınırlı, gövde kayar. -->
          <div class="table-responsive" style="max-height: 280px; overflow-y: auto;"
               *ngIf="!loading && card.rows.length">
            <table class="table table-sm align-middle mb-0">
              <thead>
                <tr>
                  <th class="ps-3">Tür</th>
                  <th class="text-end">Miktar</th>
                  <th class="text-end pe-3">Has</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of card.rows; trackBy: trackBySubType">
                  <td class="ps-3">{{ row.subType | subTypeDisplay: card.currency }}</td>
                  <td class="text-end text-nowrap" [class.text-danger]="row.quantity < 0">
                    {{ row.quantity | currencyAmount: card.currency: row.subType }}
                    <small class="text-muted">{{ card.currency | currencyWeight: row.subType }}</small>
                  </td>
                  <td class="text-end text-nowrap pe-3" [class.text-danger]="row.has < 0">
                    {{ row.has | currencyAmount: GoldNew }}
                    <small class="text-muted">{{ GoldNew | currencyWeight: null }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
